<script setup lang="ts">
  import { computed } from "vue";
  import { IconMenuHanger, Text } from "@ui-kit";
  import { useDeviceInfo } from "@plugins";
  import { useProfileOptions } from "@src/hooks";
  import { useWidgetsStore } from "@src/store";
  import MainPageAction from "./MainPageAction.vue";

  const { deviceInfo } = useDeviceInfo();
  const { hasPermission } = useProfileOptions();
  const widgets_store = useWidgetsStore();

  const isAvailableAction = computed(() => {
    return hasPermission("mobile.item_load") && deviceInfo?.value.isBarcodeScanner;
  });
</script>

<template>
  <MainPageAction v-if="isAvailableAction" @click="() => widgets_store.open('fitting')" data-testid="action-fitting">
    <template #icon>
      <IconMenuHanger />
    </template>
    <template #text>
      <Text font="body-regular-18" :wrap="false">{{ $t("Примерочная") }}</Text>
    </template>
  </MainPageAction>
</template>
